/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfRegistrationKeyDto } from '../../models/platform-api-result-of-registration-key-dto';
import { PlatformCreateRegistrationKey } from '../../models/platform-create-registration-key';

export interface PostUseraccountsActionCreateRegistrationKey$Params {
      body: PlatformCreateRegistrationKey
}

export function postUseraccountsActionCreateRegistrationKey(http: HttpClient, rootUrl: string, params: PostUseraccountsActionCreateRegistrationKey$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionCreateRegistrationKey.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>;
    })
  );
}

postUseraccountsActionCreateRegistrationKey.PATH = '/api/useraccounts/action/create-registration-key';
